<template>
  <div class="p-t-30">
    <v-form v-model="valid" ref="habilitacaoJuridicaForm">
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>
          <h1 class="text-info font-size-18">
            Cadastrar
            <strong>
              {{
              (crud.tipoCadastro=='D') ? $t('label.dirigente') : $t('label.socio')
              }}
            </strong>
          </h1>
        </div>
      </v-flex>
      <v-flex>
        <v-card>
          <v-layout row wrap>
            <v-flex xs12 sm6 p-t-20 v-if="crud.tipoCadastro=='S'">
              <fieldset>
                <legend>Tipo</legend>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-switch @change="defineTipoJuridico"
                      v-model="habitador.tipoHabilitador"
                      :label="$t('label.pessoaJurica')"
                      color="info"
                      value="J"                                    
                      hide-details
                    ></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch @change="defineTipoFisico"
                      v-model="habitador.tipoHabilitador"
                      :label="$t('label.pessoaFisica')"
                      color="info"                      
                      value="F"                    
                      hide-details
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </fieldset>
            </v-flex>

            <v-flex xs12 sm6 p-t-20>
              <fieldset>
                <legend>Nacionalidade</legend>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-switch @change="defineNacionalidadeBrasil"
                      v-model="habitador.flagEstrangeiro"
                      label="Brasileiro"
                      color="info"
                      value="0"
                      hide-details
                    ></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch @change="defineNacionalidadeEstrangeiro"
                      v-model="habitador.flagEstrangeiro"
                      label="Estrangeiro"
                      color="info"
                      value="1"
                      hide-details
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </fieldset>
            </v-flex>
            <v-flex xs12 sm6 v-bind:class="{'p-t-20': (crud.tipoCadastro=='D') }">
              <v-text-field
                v-model="habitador.nome"
                :label="$t('label.nome') + ' *'"
                validate-on-blur
                :rules="validacao.campoObrigatorio"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs8 sm4 v-if="habitador.flagEstrangeiro==='0' || !habitador.flagEstrangeiro">
              <v-text-field
                v-model="habitador.cpfCnpj"
                key="cpfCnpjMask"
                :label="(habitador.tipoHabilitador =='J') ? $t('label.cnpj') +' *' : $t('label.cpf')+' *' "
                v-mask="(habitador.tipoHabilitador =='J') ? maskCnpj : maskCpf"
                validate-on-blur
                :rules="rulesCpfCnpj(habitador.tipoHabilitador)"               
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs8 sm4 v-if="habitador.flagEstrangeiro === '1'">
              <v-text-field maxlength="14"
                v-model="habitador.cpfCnpj"
                key="cpfCnpjSemMask"
                :label="lblDocumento"
                validate-on-blur
                :rules="validacao.campoObrigatorio"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs4 sm8 v-if="crud.tipoCadastro=='D'">
              <v-text-field
                v-model="habitador.cargo"
                :label="$t('label.cargo') + ' *'"
                :rules="validacao.campoObrigatorio"
                validate-on-blur
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm2 v-if="crud.tipoCadastro=='S'">
              
              <v-text-field
                v-model="habitador.percentual"
                ref="campoPercentual"
                :label="$t('label.percentual') + ' *'"
                suffix="%"
                @keyup="campoPercent()"
                @blur="blurCampoPercent()"
                validate-on-blur
                :rules="[
                        v => !!v || $t('messages.validacao.campoObrigatorio'),
                        v => (!!v && v.replace(',','.')>0) || $t('messages.validacao.percentualZero'),
                        v=> validaPercentual(v) || $t('messages.validacao.percentualMaiorQue100') ,
                        ]"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs6 sm6 >
              <v-text-field
                v-model="habitador.nomeSocial"
                :label="$t('label.nomeSocial')"
                validate-on-blur            
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <uploadFile
                tamanhoMaximo="20MB"
                :required="true"
                :label="(habitador.flagEstrangeiro === '1' ? $t('label.anexoDocumentoIdentificacaoEstrangeiro') : $t('label.anexoDoDocumentosRGCPFCNHOutros') )+ ' *'"
                v-model="file"
                accept=".pdf, .PDF"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-layout row wrap class="p-t-10">
        <v-flex xs12>
          <div class="right p-l-10">
            <v-btn slot="activator" color="success" dark class="mb-2" @click="cadastrarAlterar()">Salvar</v-btn>
          </div>
          <div class="right">
            <v-btn @click="fnCancelar()">Cancelar</v-btn>
          </div>
        </v-flex>
      </v-layout>

    </v-form>
  </div>
</template>
<script>

import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */

export default {
  name: "dirigentesSocios-crud",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    crud: Object,
    habilitacaoLista: Object,
    erroHabilitacaoJuridica: Object,
    modelEdit:Object,
  },

  created() /*Metodo de start do componente*/{
    this.somaPercentual();
    this.defineLabels();
    if(this.crud.acao==="edit"){
      this.modelEdit.percentual = String(this.modelEdit.percentual);
      this.modelEdit.percentual = this.modelEdit.percentual.replace(".",",");
      this.habitador = this.modelEdit;
      //Se estiver vazio, solicitar upload
      if (this.modelEdit.arquivoUpload == null || this.modelEdit.arquivoUpload === "Não Encontrado")
        this.upload.novoFile = true;
      else
        this.upload.novoFile = false;

    }else{
      this.upload.novoFile = true;
    }
  },
  watch: { //Propriedades assistidas
    "habilitacaoLista.sociosLista": {
      handler() {
        this.somaPercentual();
        if (this.$refs.campoPercentual) {
          this.$refs.campoPercentual._data.errorBucket = [];
        }
      }
    },
   "habitador.flagEstrangeiro": {
      handler() {
       this.defineLabels();
      },

   }
  },
  computed:{
    habitadorPercentualAsNumber: {
      // getter
      get: function () {
        return Number(this.habitador.percentual.replace(',', '.'))
      },
      // setter
      set: function (newValue) {
        this.habitador.percentual = String(newValue).replace('.', ',');
      }
    }
  },
  data() {//Declaracao de variaveis
    return {
      habitador: {
        tipoCadastro: this.crud.tipoCadastro,
        idFornecSolicitacao: this.model.idFornecSolicitacao,
        numCgcFornecedor: this.model.numCgcFornecedor,
        tipoHabilitador: "F",
        flagEstrangeiro: "0",
        cpfCnpj: null,
        percentual: null,
        lblDocumento: ""
      },
      upload:{novoFile:true},
      percentTotal: 0,
      file: null,
      cpfCnpjSemMask: null,
      cpfCnpjMask: null,
      valid: true
     
    };
  },

  methods: {//Declaracao de todos os metodos
   
    blurCampoPercent(){
      this.habitadorPercentualAsNumber = this.customRoundNumber(this.habitadorPercentualAsNumber, 4);
    },

    campoPercent() {
      this.habitador.percentual = this.habitador.percentual.replace(
        /[^\d,]+/g,
        ""
      );
      this.habitador.percentual = this.habitador.percentual.replace(
        /[,]+/g,
        ","
      );
    },

    validaPercentual(v) {
      //validar se o percentual é menor que 100
      v = v ? v.replace(",", ".") : 0;
      const numberRoundedValue = this.customRoundNumber(Number(v), 4)
      return (numberRoundedValue + Number(this.percentTotal)) <= 100;
    },

    validaFornecedorExiste(cpfCnpj) {
      cpfCnpj = cpfCnpj.replace('.','').replace('.','').replace('-','');
      if(this.crud.acao==="edit") return true;
      var retorno = true;

      this.habilitacaoLista.sociosLista.filter(item => {
              if (item.cpfCnpj === cpfCnpj) {
                retorno = false;
             }});
      return retorno;
    },

    defineLabels(){
      //definir as labels se for estrangeiro ou nao, pessoa fisica ou nao
      if(this.habitador.tipoHabilitador === 'J'){ // habitador.tipoHabilitador é tipo string
        if(this.habitador.flagEstrangeiro === '1'){ // flagEstrangeiro é tipo string
          this.lblDocumento = 'Registro *';
        }else{
          this.lblDocumento = this.$t('label.cnpj') +' *';
        }
      } else{
         if(this.habitador.flagEstrangeiro === '1'){
          this.lblDocumento = 'Passaporte *';
        }else{
          this.lblDocumento = this.$t('label.cpf') +' *';
        }
      }
      return this.lblDocumento;
    },

    fnCancelar() {
      setTimeout(() => {
        this.crud.tipoCadastro = null;
        this.crud.show = false;
        this.crud.acao = "incluir";
        Object.keys(this.modelEdit).forEach(chave => {
          this.modelEdit[chave] = null;
        });
      }, 200);
    },

    somaPercentual() {
      //somar os percentuais cadastrados
      this.erroHabilitacaoJuridica.erro = false;
      this.percentTotal = 0;
      this.habilitacaoLista.sociosLista.filter(item => {
        if(this.crud.acao==="edit" && item.idFornecHabilitacaoJur === this.modelEdit.idFornecHabilitacaoJur){
          this.percentTotal = this.percentTotal;
          }else{
            this.percentTotal += item.percentual;
            this.percentTotal = Number(this.percentTotal.toFixed(4));
        }
      });
    },

    cadastrarAlterar(){
      // Abrir pop-up da Lei 9.433/2005

      const cpfSocio = this.habitador.cpfCnpj;
      let cadastrouSocioServidor = false;
      //incluir o novo socio ou dirigente
      if (this.$refs.habilitacaoJuridicaForm.validate()) {
      if (this.habitador.tipoCadastro === "S") {
        this.habitador.percentual =  this.habitador.percentual.replace(',','.');
      }
        fornecedorService
          .cadastrarEditarHabJuridica({
            habilitacaoJuridica: this.habitador,
            file: this.file
          },
            this.crud.acao)
          .then(response => { /*resposta do servico*/
            this.model.fornecedoresHabilitacaoJuridica = response.data; /*dados de retorno*/

            this.habilitacaoLista.dirigentesLista = [];
            this.habilitacaoLista.sociosLista = [];

            this.model.fornecedoresHabilitacaoJuridica.filter(item => {
              if (item.tipoCadastro === "D") {
                this.habilitacaoLista.dirigentesLista.push(item);
              } else {
                if(item.isFuncionarioPublico && item.cpfCnpj === cpfSocio) cadastrouSocioServidor = true;
                this.habilitacaoLista.sociosLista.push(item);
              }
            });
            if(cadastrouSocioServidor){
              this.$toasted.error("Sócio Servidor");
            }
            this.fnCancelar();
          });
      }
    },

    rulesCpfCnpj(tipoHabilitador){
      const rules = [ v => !!v || this.$t('messages.validacao.campoObrigatorio'),
                      v => !!v  && this.validaFornecedorExiste(v) || this.$t('messages.validacao.cpfCnpjJaCadastrado') ]
      if (tipoHabilitador === 'J') {
        return this.validacao.cnpj.concat(rules);
      }else{
        return this.validacao.cpf.concat(rules);
      }
    },

    configSocios(habilitacao){
      //carregar a listagem de socio ou dirigente
        this.model.fornecedoresHabilitacaoJuridica = habilitacao;

        this.habilitacaoLista.dirigentesLista = [];
        this.habilitacaoLista.sociosLista = [];

        this.model.fornecedoresHabilitacaoJuridica.filter(item => {
          if (item.tipoCadastro === "D") {
            this.habilitacaoLista.dirigentesLista.push(item);
          } else {
            this.habilitacaoLista.sociosLista.push(item);
          }
        });
        this.fnCancelar();
    },
    defineTipoFisico(){
      if (this.habitador.tipoHabilitador != 'F') {
        this.habitador.tipoHabilitador = "J" ;
      }
    },

    defineTipoJuridico(){
      if (this.habitador.tipoHabilitador != 'J') {
        this.habitador.tipoHabilitador = "F";
      }
    },

    defineNacionalidadeBrasil(){
      if (this.habitador.flagEstrangeiro != "0") {
        this.habitador.flagEstrangeiro = "1" ;
      }
    },

    defineNacionalidadeEstrangeiro(){
      if (this.habitador.flagEstrangeiro != "1") {
        this.habitador.flagEstrangeiro = "0";
      }
    }
  }
};
</script>